import { render, staticRenderFns } from "./2021-1-21.vue?vue&type=template&id=71decc13&scoped=true&"
import script from "./2021-1-21.vue?vue&type=script&lang=ts&"
export * from "./2021-1-21.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71decc13",
  null
  
)

export default component.exports